var _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3908 37C11.6717 37 5.39111 29.1493 5.39111 19.5C5.39111 9.85066 11.6717 2 19.3908 2C21.8763 2 24.3138 2.81498 26.4414 4.35946C26.702 4.54852 26.7597 4.9138 26.5707 5.17338C26.3816 5.434 26.0174 5.49382 25.7568 5.30369C23.8288 3.90659 21.6284 3.16639 19.3909 3.16639C12.3146 3.16639 6.55734 10.4937 6.55734 19.4999C6.55734 28.5061 12.3146 35.8334 19.3909 35.8334C21.6286 35.8334 23.8298 35.0943 25.7568 33.6972C26.0174 33.5081 26.3816 33.5658 26.5707 33.8275C26.7597 34.0881 26.702 34.4524 26.4414 34.6414C24.3138 36.1848 21.8764 37 19.3908 37Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7243 17.1664H2.47406C2.15255 17.1664 1.89087 16.9058 1.89087 16.5832C1.89087 16.2606 2.15256 16 2.47406 16H14.7243C15.0458 16 15.3075 16.2606 15.3075 16.5832C15.3075 16.9058 15.0458 17.1664 14.7243 17.1664Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7243 23.0004H2.47406C2.15255 23.0004 1.89087 22.7397 1.89087 22.4172C1.89087 22.0946 2.15256 21.834 2.47406 21.834H14.7243C15.0458 21.834 15.3075 22.0946 15.3075 22.4172C15.3075 22.7397 15.0458 23.0004 14.7243 23.0004Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.70715,
    y: 2.23032,
    width: 43,
    height: 3,
    transform: "rotate(45 3.70715 2.23032)",
    fill: "#FF0505",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.8e6cd041f9aff828d1021a715c67c69f.svg";
export { ForwardRef as ReactComponent };